// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__-aN4v","choiceBoxes":"toolbarselects_choiceBoxes__2G-y6","simpleField":"toolbarselects_simpleField__2BUW0"};